import { Icon } from "../../styles";
import { CircularContainer } from "./styles";
import { StyledLabelP } from "modules/Sty";

interface Props {
  step?: number | string;
  icon?: {
    alt?: string;
    src?: string;
    className?: string;
  };
}

const CircularStep = ({ step, icon }: Props) => (
  <CircularContainer>
    {icon && (
      <Icon className={icon?.className} alt={icon?.alt} src={icon?.src} />
    )}
    {!icon && (
      <StyledLabelP color="white" fontSize={18} fontWeight={400}>
        {step}
      </StyledLabelP>
    )}
  </CircularContainer>
);

export default CircularStep;
